import Operation from '@/lib/operation'

export default {
  data() {
    return {}
  },
  methods: {
    getLocalizedOperationType(operationType) {
      return Operation.getLocalizedName(operationType)
    },
  },
}
